import { Entertainer } from '@queries/EntertainerQueries';

export const getEntertainerSeoLink = (entertainer: Pick<Entertainer, '_id' | 'bookingHandle'>) => {
  return `https://my.gaggl.app/noauth/entertainer/${entertainer?.bookingHandle ?? ''}`;
};
